export default "/images/Medpage.png?88069fcbbc7b4efefaac2641b8b83147";